import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconTrendingDown = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "m14 9.586-4 4-6.293-6.293-1.414 1.414L10 16.414l4-4 4.293 4.293L16 19h6v-6l-2.293 2.293z" }) }));
const Memo = memo(SvgIconTrendingDown);
export default Memo;
//# sourceMappingURL=IconTrendingDown.js.map